import './App.css';
import RegistrationForm from './components/RegistrationForm.jsx'

function App() {
  return (
    <div className="App">
      <RegistrationForm />
    </div>
  );
}

export default App;
